/**
 * Language code normalization for accurate comparison between detected and configured languages.
 * Maps language variants and deprecated codes to their canonical form.
 */

const LANGUAGE_ALIASES = {
  cmn: 'zh',
  fil: 'tl',
  in: 'id',
  iw: 'he',
  ji: 'yi',
  nb: 'no',
  nn: 'no',
  'zh-cn': 'zh',
  'zh-hans': 'zh',
  'zh-hant': 'zh',
  'zh-hk': 'zh',
  'zh-sg': 'zh',
  'zh-tw': 'zh'
};

/**
 * Normalizes a language code to its canonical form.
 * Handles explicit aliases and extracts base language from regional variants (e.g., 'en-US' → 'en').
 */
export const normalizeLanguageCode = languageCode => {
  if (languageCode == null || languageCode === '') {
    return languageCode;
  }
  const lowerCaseCode = languageCode.toLowerCase();
  if (LANGUAGE_ALIASES[lowerCaseCode]) {
    return LANGUAGE_ALIASES[lowerCaseCode];
  }
  const baseCode = lowerCaseCode.split('-')[0];
  if (baseCode !== lowerCaseCode) {
    return LANGUAGE_ALIASES[baseCode] ?? baseCode;
  }
  return lowerCaseCode;
};

/**
 * Compares two language codes for equivalence, accounting for variants.
 */
export const areLanguageCodesEquivalent = (code1, code2) => {
  return normalizeLanguageCode(code1) === normalizeLanguageCode(code2);
};
//# sourceMappingURL=normalize-language-code.js.map